import React from 'react';
import { useIntl } from 'react-intl';
import ListItem from './ListItem';
import message from '../../utils/message';
import { colors } from '../../theme/theme';

type Props = {
  label: React.ReactNode;
  url: string;
  /** Text rendered as link content. Defaults to `url`. */
  displayText?: React.ReactNode;
  testid?: string;
  style?: React.CSSProperties;
};

const CopyableLinkRow: React.FC<Props> = ({
  label,
  url,
  displayText,
  testid,
  style,
}) => {
  const intl = useIntl();

  const handleCopy = () => {
    navigator.clipboard?.writeText(url);
    message.success(
      intl.formatMessage({
        id: 'fleetadmin.circle.inviteCodes.copied',
        defaultMessage: 'Copied to clipboard',
      })
    );
  };

  return (
    <ListItem
      testid={testid}
      style={{ margin: 0, marginBottom: '10px', ...style }}
      valueStyles={{ minWidth: 0 }}
      label={label}
      value={
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            minWidth: 0,
            width: '100%',
          }}
        >
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            title={url}
            style={{
              color: colors.blue,
              display: 'block',
              flex: 1,
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {displayText ?? url}
          </a>
          <img
            src="/images/car-editor/link.svg"
            alt="copy link"
            onClick={handleCopy}
            style={{
              cursor: 'pointer',
              width: 20,
              height: 20,
              flexShrink: 0,
            }}
          />
        </div>
      }
    />
  );
};

export default CopyableLinkRow;
